package com.gsb.vyapar.bhagya.presentation.splash.view

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.height
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.platform.LocalUriHandler
import androidx.compose.ui.unit.dp
import com.gsb.vyapar.bhagya.interactor.event.UiEvents
import com.gsb.vyapar.bhagya.interactor.uistate.UiState
import com.gsb.vyapar.bhagya.presentation.common.image.SplashImageCircularAnimated
import com.gsb.vyapar.bhagya.presentation.splash.event.SplashUiEvents
import com.gsb.vyapar.bhagya.theme.white
import com.gsb.vyapar.bhagya.util.BuildConfig
import com.gsb.vyapar.bhagya.presentation.common.text.Text14RegularBB
import com.gsb.vyapar.bhagya.presentation.common.text.Text24SemiBold
import com.gsb.vyapar.bhagya.theme.splashBack

@Composable
fun SplashView(uiState: UiState, onTriggerEvent: (UiEvents) -> Unit) {
    val uriHandler = LocalUriHandler.current
    Column(
        modifier = Modifier.fillMaxSize()
            .background(color = splashBack),
        verticalArrangement = Arrangement.Center, horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Spacer(modifier = Modifier.weight(1f))
        SplashImageCircularAnimated()
        Spacer(modifier = Modifier.height(16.dp))
        Text24SemiBold(text = "GSB-VyaparBhagya", color = white)
        Spacer(modifier = Modifier.weight(1f))
        Text14RegularBB(
            text = "Version : ${BuildConfig.getVersion()}",
            color = white
        )
        Spacer(modifier = Modifier.height(24.dp))
    }
    LaunchedEffect(Unit) { onTriggerEvent(UiEvents.SplashEvents(SplashUiEvents.GetSplashUiData(uriHandler))) }
}